module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/common/claim-modal/claim-modal.component.scss
// module id = ./src/app/modules/boxoffice-module/common/claim-modal/claim-modal.component.scss
// module chunks = 9